import React from "react";
import "./Dashelement.css";

const Dashelement = (props) => {
  return <div className={props.className}>{props.children}</div>;
};

export default Dashelement;
